import { createContext, useContext } from 'react';

/** Phase 16C (C7): "Observed at" state from useChartingData, read by every entry form. */
export interface ObservedTimeState {
  observedTime: string;
  setObservedTime: (value: string) => void;
  observedError: string | null;
}

export const ObservedTimeContext = createContext<ObservedTimeState | null>(null);

export const useObservedTime = (): ObservedTimeState | null => useContext(ObservedTimeContext);
